import { GroupedSelectOption } from '../../../../types/SelectInput'

/** Loads options for searchable async options */
export const loadAsyncQueryOptions = (
    inputValue: string,
    options: {
        asyncMinimumCharacters: number
        asyncQuery: (inputValue: string) => Promise<GroupedSelectOption<any>[]>
        isSearchable: boolean
    },
): Promise<GroupedSelectOption[]> => {
    const isValidSearch: boolean = inputValue?.length >= options.asyncMinimumCharacters
    const emptyResults = new Promise<GroupedSelectOption[]>((resolve) => resolve([]))

    if (!options.asyncQuery) return emptyResults
    if (!options.isSearchable) return options.asyncQuery('') // gets all results if not searchable

    return isValidSearch ? options.asyncQuery(inputValue) : emptyResults
}
